import type { SVGProps } from 'react';

export const Home = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 19h3.35v-5.05c0-.25.083-.458.25-.625a.889.889 0 0 1 .65-.275h3.5a.81.81 0 0 1 .625.275.81.81 0 0 1 .275.625V19H18v-8.85a.17.17 0 0 0-.05-.125.315.315 0 0 0-.075-.125l-5.7-4.275a.24.24 0 0 0-.35 0L6.125 9.9a.819.819 0 0 0-.1.125.278.278 0 0 0-.025.125V19Zm-1.5 0v-8.85c0-.283.058-.55.175-.8.133-.267.317-.483.55-.65l5.7-4.275A1.69 1.69 0 0 1 12 4.05c.4 0 .758.125 1.075.375l5.7 4.275c.233.167.408.383.525.65.133.25.2.517.2.8V19c0 .417-.15.775-.45 1.075A1.426 1.426 0 0 1 18 20.5h-3.95a.934.934 0 0 1-.65-.25.934.934 0 0 1-.25-.65v-5.05h-2.3v5.05a.89.89 0 0 1-.275.65.848.848 0 0 1-.625.25H6c-.417 0-.775-.142-1.075-.425A1.511 1.511 0 0 1 4.5 19Z" />
    </svg>
  );
};
